// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessageNone_container__YHtzL {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    cursor: default;
}

.MessageNone_main__2jEJs {
    width: 100%;
    /* height: 50%; */
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    /* padding: 0 60px 70px 60px; */
    padding: 0 104px 70px 60px;
}

.MessageNone_bg_box__V3Ozo {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 50px;
}

.MessageNone_bg_agent__HEcZw {
    width: 93px;
    height: 93px;
    margin-bottom: 20px;
}

.MessageNone_title_llm__Y-POG {
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    color: #101417;
    font-size: 20px;
    line-height: 28px;
}

.MessageNone_message_input__NUqR5 {
    width: 100%;
    margin-bottom: 20px;
}

.MessageNone_butn_list__2LtGH {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    height: 173px;
}

.MessageNone_butn_box__R-iLj {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 132px;
    height: 40px;
    padding: 8px 16px;
    border: 1px solid #c1c1c1;
    border-radius: 6px;
    cursor: pointer;
    background-color: #fff;
    transition: background-color 0.5s, box-shadow 0.5s;
    -webkit-user-select: none;
            user-select: none;
}

.MessageNone_butn_box__R-iLj:not(:last-child) {
    margin-right: 24px;
}

.MessageNone_butn_box__R-iLj:hover {
    background-color: #e4f0f2;
    box-shadow: 0px 4px 4px rgba(255, 255, 255, 0.25);
}

.MessageNone_butn_box__R-iLj:active {
    background-color: #74bdc6;
    box-shadow: 0px 4px 4px rgba(255, 255, 255, 0.25);
}

.MessageNone_butn_img__tiQfq {
    max-width: 24px;
    max-height: 24px;
}

.MessageNone_butn_text__M5TYc {
    font-size: 13px;
    color: #000;
}

.MessageNone_current_butn_list__C35bx {
    width: 100%;
    padding: 0 0 8px 0;
}

.MessageNone_current_butn_box__Nh9W8 {
    width: 100%;
    height: 43px;
    padding-left: 10px;
    margin-bottom: 12px;
    cursor: pointer;
}

.MessageNone_current_butn_box__Nh9W8:not(:last-child) {
    border-bottom: 1px solid #CACFDB;
}

.MessageNone_current_butn_box__Nh9W8:hover {
    background-color: #f9f9f9;
    border-bottom: 1px solid #f9f9f9;
    border-radius: 6px;
}

.MessageNone_current_butn_text__wjk\\+O {
    color: #323a45;
    line-height: 43px;
}
.MessageNone_mobile_container__DVBVS .MessageNone_message_input__NUqR5 {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 20px 20px;
    width: auto;
}
.MessageNone_mobile_ios_container__uTLJo .MessageNone_message_input__NUqR5 {
    margin: 0 20px 40px!important;
}
.MessageNone_mobile_container__DVBVS .MessageNone_main__2jEJs {
    padding: 0;
}
.MessageNone_mobile_container__DVBVS .MessageNone_bg_box__V3Ozo {
    margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/components/MessageNone/index.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,+BAA+B;IAC/B,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,kDAAkD;IAClD,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,iDAAiD;AACrD;;AAEA;IACI,yBAAyB;IACzB,iDAAiD;AACrD;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,6BAA6B;AACjC;AACA;IACI,UAAU;AACd;AACA;IACI,gBAAgB;AACpB","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    cursor: default;\n}\n\n.main {\n    width: 100%;\n    /* height: 50%; */\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    align-items: center;\n    /* padding: 0 60px 70px 60px; */\n    padding: 0 104px 70px 60px;\n}\n\n.bg_box {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 50px;\n}\n\n.bg_agent {\n    width: 93px;\n    height: 93px;\n    margin-bottom: 20px;\n}\n\n.title_llm {\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    color: #101417;\n    font-size: 20px;\n    line-height: 28px;\n}\n\n.message_input {\n    width: 100%;\n    margin-bottom: 20px;\n}\n\n.butn_list {\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    width: 100%;\n    height: 173px;\n}\n\n.butn_box {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 132px;\n    height: 40px;\n    padding: 8px 16px;\n    border: 1px solid #c1c1c1;\n    border-radius: 6px;\n    cursor: pointer;\n    background-color: #fff;\n    transition: background-color 0.5s, box-shadow 0.5s;\n    user-select: none;\n}\n\n.butn_box:not(:last-child) {\n    margin-right: 24px;\n}\n\n.butn_box:hover {\n    background-color: #e4f0f2;\n    box-shadow: 0px 4px 4px rgba(255, 255, 255, 0.25);\n}\n\n.butn_box:active {\n    background-color: #74bdc6;\n    box-shadow: 0px 4px 4px rgba(255, 255, 255, 0.25);\n}\n\n.butn_img {\n    max-width: 24px;\n    max-height: 24px;\n}\n\n.butn_text {\n    font-size: 13px;\n    color: #000;\n}\n\n.current_butn_list {\n    width: 100%;\n    padding: 0 0 8px 0;\n}\n\n.current_butn_box {\n    width: 100%;\n    height: 43px;\n    padding-left: 10px;\n    margin-bottom: 12px;\n    cursor: pointer;\n}\n\n.current_butn_box:not(:last-child) {\n    border-bottom: 1px solid #CACFDB;\n}\n\n.current_butn_box:hover {\n    background-color: #f9f9f9;\n    border-bottom: 1px solid #f9f9f9;\n    border-radius: 6px;\n}\n\n.current_butn_text {\n    color: #323a45;\n    line-height: 43px;\n}\n.mobile_container .message_input {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: 0 20px 20px;\n    width: auto;\n}\n.mobile_ios_container .message_input {\n    margin: 0 20px 40px!important;\n}\n.mobile_container .main {\n    padding: 0;\n}\n.mobile_container .bg_box {\n    margin-bottom: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MessageNone_container__YHtzL`,
	"main": `MessageNone_main__2jEJs`,
	"bg_box": `MessageNone_bg_box__V3Ozo`,
	"bg_agent": `MessageNone_bg_agent__HEcZw`,
	"title_llm": `MessageNone_title_llm__Y-POG`,
	"message_input": `MessageNone_message_input__NUqR5`,
	"butn_list": `MessageNone_butn_list__2LtGH`,
	"butn_box": `MessageNone_butn_box__R-iLj`,
	"butn_img": `MessageNone_butn_img__tiQfq`,
	"butn_text": `MessageNone_butn_text__M5TYc`,
	"current_butn_list": `MessageNone_current_butn_list__C35bx`,
	"current_butn_box": `MessageNone_current_butn_box__Nh9W8`,
	"current_butn_text": `MessageNone_current_butn_text__wjk+O`,
	"mobile_container": `MessageNone_mobile_container__DVBVS`,
	"mobile_ios_container": `MessageNone_mobile_ios_container__uTLJo`
};
export default ___CSS_LOADER_EXPORT___;
